import { post, get } from '../../../../services/request';

// Get all
export const getAllReportConfiguration = (startDate = '', endDate = '') => {
    return get(`PerformanceDashboard/GetAllPerformanceDashboardConfigList?StartDate=${startDate}&EndDate=${endDate}`);
};

// Get by ID
export const getReportConfigurationById = (ReportConfigurationID) => {
    return get(`PerformanceDashboard/GetPerformanceDashboardConfigByID?PerformanceDashboardConfigID=${ReportConfigurationID}`);
};
    
// Save/update
export const saveReportConfiguration = (ReportConfigurationData) => {
    return post('PerformanceDashboard/SavePerformanceDashboardConfig', ReportConfigurationData);
};

// Activate/Deactivate
export const activateDeactivateReportConfiguration = (ReportConfigurationID, status, userId) => {
    return post('PerformanceDashboard/ActivateDeactivate', {
        Id: ReportConfigurationID,
        Status: status,
        UserId: userId
    });
};

// Get PowerBI Reports Refresh Status
export const getPowerBIReportsRefresh = () => {
    return get('DemandTable/GetDemandTablePowerBIReportsRefresh');
};

// Get Capacity Dropdown
export const getCapacityDropdown = (fromDate, toDate, configId = 0) => {
    return get(`PerformanceDashboard/GetPerformanceDashboardCapacityDropDown?FromDate=${encodeURIComponent(fromDate)}&ToDate=${encodeURIComponent(toDate)}&configId=${configId}`);
};